import React from 'react';
import StaticOfferContainer from 'partial/OfferManager/StaticOfferContainer';
import { StandardPersonalLoanOfferRedesign } from 'components/Offers/StandardPersonalLoanOfferRedesign';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { parsePlPrequalOffer } from '../PersonalLoanPrequalResultModule/hooks/PersonalLoanPrequalResultModule.hook';
import { StandardPersonalLoanOfferRedesignExp } from 'components/Offers/StandardPersonalLoanOfferRedesignExp/StandardPersonalLoanOfferRedesignExp';

const PersonalLoanOfferView = props => {
  const { plOffers, plPrequalOfferFlag, plPrequalResult, toPersonalLoanPage } =
    props;
  const { offers, partnerDetails } = plPrequalResult || {};
  const parsedOffers = plOffers
    ?.slice(0, 1)
    .map((offer, index) =>
      parsePlPrequalOffer(offer, index + 1, { partnerDetails }),
    );

  let personalLoanTemplate = StandardPersonalLoanOfferRedesign;
  if (plPrequalOfferFlag?.config?.enabled) {
    personalLoanTemplate = StandardPersonalLoanOfferRedesignExp;
  }

  return (
    <FlexContainer className={'flex-container'}>
      <StaticOfferContainer
        offerMetadataList={parsedOffers}
        personalLoanTemplate={personalLoanTemplate}
        pagePosition={props.offerInfo}
        modulePosition={props.modulePosition}
        eventHandler={props.eventHandler}
        vertical={'Personal Loan'}
        offerType={props.offerInfo}
        quantityOfOffers={offers?.length - 1}
        toPersonalLoanPage={toPersonalLoanPage}
      />
    </FlexContainer>
  );
};

export default PersonalLoanOfferView;
